module.exports = __webpack_public_path__ + "img/img_0.d847505e.png";